import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/models/user.model';
import { VersionModel } from 'src/models/version.model';
import { LoginRepository } from 'src/repository/login/login.repository';
import { VersionRepository } from 'src/repository/version/version.repository';
import { AlertService } from 'src/services/alert/alert.service';
import { RouterService } from 'src/services/router/router.service';
import { UserStorage } from 'src/storage/user/user.storage';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public cliente: UserModel = new UserModel();
  public inlogin: boolean = false;
  public error;
  public message;
  public version: VersionModel;

  constructor(
    private versionrep: VersionRepository,
    private loginrepo: LoginRepository,
    private userstorage: UserStorage,
    private alertservice: AlertService,
    private router: RouterService
  ) {
    this.getVersion();
  }

  ngOnInit(): void {}

  public async login() {
    this.inlogin = true;
    try {
      let user = await this.loginrepo.login(this.cliente.toJsonLogin());
      if (!!user.hash) {
        this.userstorage.user = user;
        console.log('Usuário logado => ', user);
        this.router.go('listnfs');
      } else {
        this.alertservice.sendAlert(
          'Combinação Usuário/Senha inválida!',
          'danger'
        );
      }
    } catch (error) {
      // this.uteis.alertDanger('Erro ao realizar login!');
      this.alertservice.sendAlert('Erro ao realizar login!', 'danger');
    }
    this.inlogin = false;
  }

  async getVersion() {
    try {
      this.version = await this.versionrep.getVersion();
    } catch (error) {}
  }

  ngOnDestroy(): void {
    window.speechSynthesis.pause();
  }
}
